export const SAVE_PRECHAT = 'SAVE_PRECHAT';
export const RESET_PRECHAT = 'RESET_PRECHAT';
export const UPDATE_CATEGORY_FORM_DATA = 'UPDATE_CATEGORY_FORM_DATA';
export const UPDATE_CATEGORY_STATE = 'UPDATE_CATEGORY_STATE';
export const PRECHAT_RESET_STATE = 'PRECHAT_RESET_STATE';